import { Box, Icon, InlineStack, Link, Spinner, TextLabel } from '@customerio/pluma-components/react';
import type { RelatedModel } from './delivery-row-expansion-hooks';

type DeliveryRelatedLinkProps = {
  model: RelatedModel;
  isLoading: boolean;
};

/**
 * The related-message column: a labelled link to the delivery's parent campaign
 * / newsletter / transactional message. Renders nothing when the delivery has
 * no parent message (e.g. an action-scoped delivery).
 */
export function DeliveryRelatedLink({ model, isLoading }: DeliveryRelatedLinkProps) {
  if (isLoading) {
    return <Spinner data-test-delivery-row-expansion-campaign-name-spinner />;
  }

  if (model.kind === 'none') {
    return null;
  }

  if (model.kind === 'transactional') {
    return (
      <Box data-test-delivery-row-expansion-transactional>
        <TextLabel mb="100">Transactional message:</TextLabel>
        <InlineStack alignBlock="center" gap="100">
          <Icon name="transactional-api" display="block" />
          <Link href={model.href} variant="primary" data-test-delivery-row-expansion-message-link>
            {model.name}
          </Link>
        </InlineStack>
      </Box>
    );
  }

  const label =
    model.kind === 'campaign' ? `Triggered ${model.isApiTriggered ? 'broadcast' : 'automation'}:` : 'One-time send:';

  return (
    <Box data-test-delivery-row-expansion-related>
      <TextLabel mb="100">{label}</TextLabel>
      <Box truncate minW="0">
        <Link href={model.href} variant="primary">
          {model.name}
        </Link>
      </Box>
    </Box>
  );
}
